import { useState, useMemo } from 'react';
import questionnaires from '../views/pages/QuestionnaireBuilder/questionnaireTemplates';

export const useQuestionnaires = () => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 5 });

    const paginatedData = useMemo(() => {
        const start = paginationModel.page * paginationModel.pageSize;
        return questionnaires.slice(start, start + paginationModel.pageSize);
    }, [paginationModel]);

    return {
        data: paginatedData,
        isLoading: false,
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions: [3, 5, 10],
        count: questionnaires.length
    };
};
